import React, { useEffect, useState } from 'react';
import { format } from 'date-fns';

type Props = {
  className?: string;
};

const Clock: React.FC<Props> = ({ className = 'col-7' }) => {
  const [date, setDate] = useState(new Date());

  const tick = () => {
    setDate(new Date());
  };

  useEffect(() => {
    const timerID = setInterval(() => tick(), 1000);
    return function cleanup() {
      clearInterval(timerID);
    };
  });

  return <h2 className={className}>{format(date, 'dd.LL.yyyy HH:mm:ss')}</h2>;
};

export default Clock;
